<div>
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <div mat-dialog-title class="matp-dialog-title">インポート</div>

  <mat-dialog-content class="tw-w-full !tw-pt-2">
    <div
      class="tw-w-full tw-text-center tw-flex tw-items-center tw-justify-center"
    >
      <div
        class="tw-ml-2 tw-w-80 tw-border-0 tw-border-b-[1px] tw-border-solid tw-h-9 tw-leading-9 tw-truncate"
      >
        {{ fileName }}
      </div>
      <input
        hidden
        (change)="onFileSelected()"
        #fileInput
        id="file"
        type="file"
        name="file"
        accept=".csv"
      />
      <button
        id="input-file-btn"
        mat-raised-button
        class="tw-w-37 tw-ml-2"
        color="primary"
        (click)="fileInput.click()"
      >
        <mat-icon>attach_file</mat-icon>
        参照
      </button>
    </div>
    <div class="tw-flex tw-ml-28">
      <mat-error *ngIf="fileControl.hasError('incorrectFileType')">
        CSVファイルを選択してください。
      </mat-error>
      <mat-error *ngIf="fileControl.hasError('rowCountExceeded')">
        CSVのデータ行数は100行以下にしてください。<br />（ヘッダ行・空行を除く）
      </mat-error>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4">
    <button id="cancel-btn" mat-raised-button mat-dialog-close class="tw-w-40">
      <mat-icon>close</mat-icon>
      キャンセル
    </button>
    <button
      id="import-btn"
      mat-raised-button
      color="accent"
      class="tw-w-40"
      [disabled]="!fileInput.value || fileControl.invalid"
      (click)="bulkAdd()"
    >
      <mat-icon>done</mat-icon>
      <span>インポート</span>
    </button>
  </mat-dialog-actions>
</div>
